import { Loadable } from '../../util/Loadable';
import { PromotedGame, PromotionAppState } from './types';

export const getPromotedGame = (state: PromotionAppState): Loadable<PromotedGame | undefined> => state.promotion.currentPromotion;
